import { render, staticRenderFns } from "./VaProgressCircle.vue?vue&type=template&id=2ab5f9e9&"
import script from "./VaProgressCircle.vue?vue&type=script&lang=js&"
export * from "./VaProgressCircle.vue?vue&type=script&lang=js&"
import style0 from "./VaProgressCircle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports